
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetSelectIec as ObiTargetSelectIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-select-iec.js';
 
 
 

 
 export const ObiTargetSelectIec = createComponent({
   react: React,
   tagName: 'obi-target-select-iec',
   elementClass: ObiTargetSelectIecElement,
   events: {
     
   }
  });
 
 